import { productTypes } from '@/helpers/products/productTypes/types'
import {
  ROUTE_AI_ASSISTANTS,
  ROUTE_ROOT,
  ROUTE_USER_CREATE,
  ROUTE_USER_EDIT,
  ROUTE_USER_PLAYTHROUGHS,
  ROUTE_REDIRECT_FAST,
} from '@/router/routes/routeNames'
import { redirectAuthenticatedFAST } from '@/router/middlewares/redirectAuthenticatedMiddleware'

const redirectRoutes = [
  // The Overview page was removed (FAME-827); old bookmarks go to the landing page.
  {
    path: '/home',
    redirect: { name: ROUTE_ROOT },
  },
  {
    path: '/user/create',
    redirect: { name: ROUTE_USER_CREATE },
  },
  {
    path: '/user/:userId',
    redirect: { name: ROUTE_USER_EDIT },
  },
  {
    path: '/user/:userId/products',
    redirect: { name: ROUTE_USER_PLAYTHROUGHS },
  },
  // Assistants are edited in Manager now; this precedes the generic Fast route
  // so old bookmarks land on the list instead of Fast's root
  {
    path: `/redirect/fast/${productTypes.AI_ASSISTANT}`,
    redirect: { name: ROUTE_AI_ASSISTANTS },
  },
  {
    name: ROUTE_REDIRECT_FAST,
    path: '/redirect/fast/:productType?',
    beforeEnter: async (to) => {
      await redirectAuthenticatedFAST(to.params.productType)
    },
    meta: { resource: 'Product' },
  },
]

export default redirectRoutes
